import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.MARKETING_AND_SALES}.${BUSINESS_TOOL_SUB_SECTIONS.MARKETING_AND_SALES.MARKETING_PLAN}` as const;

export const MARKETING_NAMES = {
  ADVERTISING_CAMPAIGNS: 'advertisingCampaigns',
  BUDGET: 'budget',
  BRAND_ELEMENTS: 'brandElements',
  POSITIONING: 'positioning',
  PRICING_STRATEGY: 'pricingStrategy',
  TOOLS_AND_TECHNOLOGIES: 'toolsAndTechnologies',
} as const;

export interface IMarketing {
  [MARKETING_NAMES.ADVERTISING_CAMPAIGNS]: string;
  [MARKETING_NAMES.BUDGET]: string;
  [MARKETING_NAMES.BRAND_ELEMENTS]: string;
  [MARKETING_NAMES.POSITIONING]: string;
  [MARKETING_NAMES.PRICING_STRATEGY]: string;
  [MARKETING_NAMES.TOOLS_AND_TECHNOLOGIES]: string;
}

export const marketingInitialValues = {
  [MARKETING_NAMES.ADVERTISING_CAMPAIGNS]: '',
  [MARKETING_NAMES.BUDGET]: '',
  [MARKETING_NAMES.BRAND_ELEMENTS]: '',
  [MARKETING_NAMES.POSITIONING]: '',
  [MARKETING_NAMES.PRICING_STRATEGY]: '',
  [MARKETING_NAMES.TOOLS_AND_TECHNOLOGIES]: '',
}